import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { modelServices } from "../../scripts/ah.mb.ui.model-services"
import { MessageBox } from "uiv";

@Component
export default class AutoTagModelDialog extends Vue {

    @Prop()
    value: string;

    @Prop()
    modelServices: modelServices;

    matchWholeNodeNamesOnly: boolean = false;

    isBusy: boolean = false;
    // Todo: Implement

    // Create user notifier
    private userNotifier = new ClientNotifier();

    onAutoTagModelClick() {

        this.isBusy = true;
        var notification = this.userNotifier.showBusyNotification(`Auto-tagging ${this.value}...`);
        this.modelServices.autoTagModel(this.value, this.matchWholeNodeNamesOnly)
            .then((data) => {
                this.userNotifier.clear(notification);
                // Data is a string with carriage returns in it - change to <br>
                var formatted = data.response.split("\r\n").join("<br>");
                MessageBox.alert({ title: "Auto-tag Model", content: formatted, html: true });
                //                            bootbox.alert(formatted, () => { });
                this.isBusy = false;

                this.$emit("dialogClosed", "ok");


            });

    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/auto-tag-model-dialog/auto-tag-model-dialog.ts